import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.issues.fields.id'),
  },
  {
    name: 'pillar',
    label: i18n('entities.issues.fields.pillar'),
  },
  {
    name: 'topic',
    label: i18n('entities.issues.fields.topic'),
  },
  {
    name: 'issue',
    label: i18n('entities.issues.fields.issue'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.issues.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.issues.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
